import { rankingData } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热度榜单</h2>
          <p className="text-sm text-foreground-500 mt-2">实时电视剧热度排名，看看大家都在追什么</p>
        </div>

        <div className="max-w-[700px] mx-auto bg-background-100 rounded-2xl overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-white'
                  : item.rank === 2
                  ? 'bg-background-300 text-foreground-700'
                  : item.rank === 3
                  ? 'bg-background-300/70 text-foreground-600'
                  : 'bg-transparent text-foreground-400'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-foreground-900 truncate">{item.title}</div>
                <div className="text-xs text-foreground-400">{item.category}</div>
              </div>

              <div className="text-sm font-medium text-primary-500 whitespace-nowrap flex-shrink-0">
                {item.heat}
              </div>

              <div className={`flex items-center gap-0.5 text-xs font-medium whitespace-nowrap flex-shrink-0 ${
                item.trend === 'up'
                  ? 'text-accent-600'
                  : item.trend === 'down'
                  ? 'text-foreground-400'
                  : 'text-secondary-500'
              }`}>
                {item.trend === 'up' && <i className="ri-arrow-up-s-line"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-s-line"></i>}
                {item.trend === 'new' && <i className="ri-star-line"></i>}
                <span>{item.change}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}